module.exports = {"title":"Filters","filterBtn":"Filter","apply":"Apply","applyAndSearch":"Apply And Search","checkinStatus":"Check-in Status","checkedIn":"Checked In","checkedOut":"Checked Out","transactionStatus":"Transaction Status","completed":"Completed","error":"Error","released":"Released","reserved":"Reserved","tentative":"Tentative","vipatron":"VIPatron","coupons":"Coupons","tags":"Tags"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/Filters/locales/fr.json
// module id = 1431
// module chunks = 0